/* eslint-disable react/prop-types */
import React, {Component} from 'react'

import PropTypes from 'prop-types'

import CardArticle from '@s-ui/react-card-article'
import Masonry from '@s-ui/react-list-masonry'
import {SaitamaAd} from '@adv-mt/advertising-publift'
import IconComments from '@adv-mt/mt-svg-icons/lib/Comments.js'
import TagChip from '@adv-mt/mt-tag-chip'

// legacy way to make Play icon work with CardArticle component, kept for backwards compatibility
const IconPlay = ({svgClass}) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={svgClass} viewBox="0 0 64 64">
    <path
      d="M32,64C14.3,64,0,49.7,0,32S14.3,0,32,0s32,14.3,32,32S49.7,64,32,64z M32,4C16.5,4,4,16.5,4,32s12.5,28,28,28
s28-12.5,28-28S47.5,4,32,4z"
    ></path>
    <polygon points="26,46.9 26,17.1 44,32"></polygon>
  </svg>
)

class FeedArticles extends Component {
  _buildArticles = (feed, imagesAspectRatio, linkFactory, renderCardActions) =>
    feed.map(item => {
      let {url, img, tag, comments, title, description, featured, video} = item
      const media = {
        src: img,
        icon: IconPlay
      }
      if (tag) {
        tag = {
          ...tag,
          text: tag.text.toUpperCase(),
          type: tag.id
        }
      }
      if (comments) {
        comments = {
          ...comments,
          icon: IconComments
        }
      }

      const itemKey = item.articleId ?? title

      const card = (
        <CardArticle
          link={url}
          linkFactory={linkFactory}
          media={media}
          tag={tag}
          tagChip={TagChip}
          comments={comments}
          title={title}
          featured={featured}
          description={description}
          lazyLoad={{aspectRatio: imagesAspectRatio}}
          video={video}
          key={itemKey}
        />
      )

      if (!renderCardActions) return card

      const cardActions = renderCardActions(item)
      return (
        <div className="mt-FeedArticles-itemWrapper" key={itemKey}>
          {card}
          {cardActions && <div className="mt-FeedArticles-itemActions">{cardActions}</div>}
        </div>
      )
    })

  _buildItems = (feed, imagesAspectRatio, emptyCardPosition, linkFactory, renderCardActions, showInlineAd = true) => {
    if (feed.length === 0) {
      return []
    }

    const articles = this._buildArticles(feed, imagesAspectRatio, linkFactory, renderCardActions)
    if (!showInlineAd) return articles
    return [
      ...articles.slice(0, emptyCardPosition),
      <SaitamaAd id="ad-inline-1" />,
      ...articles.slice(emptyCardPosition)
    ]
  }

  render() {
    const {
      feed,
      imagesAspectRatio,
      emptyCardPosition,
      linkFactory,
      breakPoints,
      onColumnsReady,
      renderCardActions,
      showInlineAd
    } = this.props
    const items = this._buildItems(
      feed,
      imagesAspectRatio,
      emptyCardPosition,
      linkFactory,
      renderCardActions,
      showInlineAd
    )

    return (
      <div className="mt-FeedArticles">
        <Masonry breakPoints={breakPoints} onColumnsReady={onColumnsReady}>
          {items.map((item, index) => (
            <div className="mt-FeedArticles-item" key={index}>
              {item}
            </div>
          ))}
        </Masonry>
      </div>
    )
  }
}

export default FeedArticles

FeedArticles.propTypes = {
  feed: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      url: PropTypes.string,
      img: PropTypes.string,
      tag: PropTypes.shape({
        id: PropTypes.string,
        url: PropTypes.string,
        text: PropTypes.string,
        rel: PropTypes.string
      }),
      comments: PropTypes.shape({
        count: PropTypes.number,
        url: PropTypes.string
      }),
      title: PropTypes.string,
      description: PropTypes.string,
      featured: PropTypes.bool,
      video: PropTypes.bool
    })
  ),
  imagesAspectRatio: PropTypes.string,
  emptyCardPosition: PropTypes.number,
  linkFactory: PropTypes.func,
  breakPoints: PropTypes.array,
  onColumnsReady: PropTypes.func,
  renderCardActions: PropTypes.func,
  showInlineAd: PropTypes.bool
}
